import { createApi } from '@thinknimble/tn-models'
import { axiosInstance } from '../axios-instance'
import { guestShape } from './models'

export const guestApi = createApi({
  baseUri: '/stays/guests/',
  client: axiosInstance,
  models: {
    entity: guestShape,
  },
})
